// types
import type { ResolvedArchiveData } from '@/app/archives/archivesGetAll';
import archivesGetAll from '@/app/archives/archivesGetAll';
import Archives from '@/interface/ui/archives/index';
import { appFetchSucceeded } from '@/store/ducks/app/index';
import { appUserAgentDetermined } from '@/store/ducks/app/index';
import {
  archivesLoadSucceeded,
  shortcutsForArchiveLoadSucceeded,
} from '@/store/ducks/domain/archives';
import type { RootState } from '@/store/index';
import Shortcut from '@/domain/shortcuts';
import { shorcutsForArchiveGetAll } from '@/app/shortcuts/shortcutsGetAll';
import archiveGetEvents, {
  ResolvedEventData,
} from '@/app/events/archiveGetEvents';
import { archivedEventLoadSucceeded } from '@/store/ducks/domain/archivedEvents';

async function fetchAndStore(store, path: string) {
  const data = await archivesGetAll();
  const shortcutData = await shorcutsForArchiveGetAll();
  const eventData = await archiveGetEvents();

  store.dispatch(archivesLoadSucceeded(data));
  store.dispatch(shortcutsForArchiveLoadSucceeded(shortcutData.shortcuts));
  store.dispatch(archivedEventLoadSucceeded(eventData));
  store.dispatch(appFetchSucceeded([path]));
}

(Archives as any).getInitialProps = async ({ req, store, asPath }) => {
  const isClient = req === undefined;
  if (isClient) {
    const { app }: RootState = store.getState();
    const { fetchedPaths, userAgent } = app;
    if (!fetchedPaths.includes(asPath)) {
      await fetchAndStore(store, asPath);
    }

    if (!userAgent) {
      const userAgent = req ? req.headers['user-agent'] : navigator.userAgent;
      store.dispatch(appUserAgentDetermined(userAgent));
    }

    return { mode: 'default' };
  }

  await fetchAndStore(store, asPath);

  const userAgent = req ? req.headers['user-agent'] : navigator.userAgent;
  store.dispatch(appUserAgentDetermined(userAgent));

  return {
    mode: 'default',
  };
};

export default Archives;
